import DialogFunctions from "../../../core/dialogFunctions";

class ApproveReimbursementDialogController extends DialogFunctions {
  constructor($mdDialog, FineReimbursement) {
    "ngInject";

    super($mdDialog);

    this.FineReimbursement = FineReimbursement;
  }

  $onInit() {
    this.FineReimbursement.getReasons({ type: "reject" }).$promise.then(
      (response) => {
        this.reasons = response;
      }
    );
  }
}

export default ApproveReimbursementDialogController;



// WEBPACK FOOTER //
// ./src/pages/fineReimbursement/rejectReimbursementDialog/rejectReimbursementDialog.controller.js